module.exports = __webpack_public_path__ + "assets/img/Pink_Dating.b6454f36.svg";